import React from 'react';
import { Icon } from '@global-ecom/nitro-uds/elements';

import { usePayPal } from 'hooks/usePayPal';
import { Button as LegacyButton } from 'ui/elements/Button';
import { AnalyticsEvents, event, paymentClickEvent } from 'utils/analytics';
import { useFeature } from 'hooks/useFeature';
import { useTranslate } from 'hooks/useTranslations';
import { PaymentMethod } from 'utils/constants';

export const PayPalButton = ({
  disabled,
  loading,
}: {
  disabled?: boolean;
  loading?: boolean;
  useTextLogo?: boolean;
}) => {
  const t = useTranslate();
  const isPayPalEnabled = useFeature(PaymentMethod.PAYPAL);
  const [{ fetching }, startPayPal] = usePayPal(!isPayPalEnabled);

  if (!isPayPalEnabled) return null;

  return (
    <LegacyButton
      dataTestId="continue-with-paypal-button"
      className="w-full bg-white border-puma-black-700 hover:(bg-neutral-20 border-neutral-20)"
      height="tall"
      label={t('continueWithPayPal')}
      loading={fetching || loading}
      disabled={fetching || loading || disabled}
      onClick={() => {
        startPayPal();
        event(AnalyticsEvents.MINICART, {
          domevent: 'button clicked',
          domlabel: 'paypal',
        });
        event(AnalyticsEvents.PAYMENT_TYPE_SELECTED, {
          ecommerce: {
            name: AnalyticsEvents.PAYMENT_TYPE_SELECTED,
            value: 'Paypal',
          },
        });
        paymentClickEvent();
      }}
      type="button"
    >
      <Icon name="payment-paypal" size="10xl" />
    </LegacyButton>
  );
};
